import React from "react";
import styled from "styled-components";
import { useTheme } from "@material-ui/core";

export const ButtonsList = ({ buttons, noPadding }) => {
  const theme = useTheme();
  return (
    <ButtonsListContainer theme={theme}>
      <ul>
        {buttons.map((button, index) => (
          <li
            key={index}
            onClick={button.onClick}
            className={button.isDisabled ? "disabled" : ""}
          >
            <i className={`fa fa-${button.icon}`} aria-hidden="true"></i>
          </li>
        ))}
      </ul>
    </ButtonsListContainer>
  );
};

const ButtonsListContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
    overflow: hidden;
    display: flex;
  }
  li {
    margin: 4px;
  }
  i {
    display: block;
    color: ${(props) => props.theme.palette.text.main};
    text-align: center;
    padding: 16px;
    text-decoration: none;
    cursor: pointer;
  }
  i:hover {
    color: ${(props) => props.theme.palette.primary.main};
  }
  li.disabled i {
    color: ${(props) => props.theme.palette.text.disabled};
    cursor: not-allowed;
  }
  li.disabled i:hover {
    color: ${(props) => props.theme.palette.text.disabled};
  }
`;
